(function () {
  var namespace = 'TCEProcessMotionV1R2';

  if (window[namespace]) {
    window[namespace].init(document);
    return;
  }

  var states = new Map();
  var frame = 0;
  var listening = false;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function clamp(value) {
    return Math.max(0, Math.min(1, value));
  }

  function easeOut(value) {
    return 1 - Math.pow(1 - value, 3);
  }

  function findProcesses(root) {
    var processes = [];

    if (root instanceof Element && root.matches('.tce-home__process')) {
      processes.push(root);
    }
    if (root.querySelectorAll) {
      processes = processes.concat(Array.from(root.querySelectorAll('.tce-home__process')));
    }

    return processes;
  }

  function itemProgress(progress, index, count, stagger) {
    var totalStagger = Math.max(0, count - 1) * stagger;
    return clamp((progress - index * stagger) / Math.max(0.01, 1 - totalStagger));
  }

  function applyCard(card, progress) {
    var eased = easeOut(progress);
    card.style.opacity = String(0.18 + 0.82 * eased);
    card.style.translate = '0 ' + (90 * (1 - eased)).toFixed(2) + 'px';
    card.style.rotate = 'x ' + (12 * (1 - eased)).toFixed(2) + 'deg';
    card.style.willChange = progress > 0 && progress < 1 ? 'opacity, translate, rotate' : 'auto';
  }

  function applyImage(image, progress) {
    var eased = easeOut(progress);
    image.style.opacity = String(0.14 + 0.86 * eased);
    image.style.translate = '0 ' + (42 * (1 - eased)).toFixed(2) + 'px';
    image.style.rotate = (-3 * (1 - eased)).toFixed(2) + 'deg';
    image.style.scale = String(1 + 0.08 * (1 - eased));
    image.style.willChange = progress > 0 && progress < 1 ? 'opacity, translate, rotate, scale' : 'auto';
  }

  function updateState(state) {
    var rect = state.trigger.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var start = viewportHeight * 0.82;
    var end = viewportHeight * 0.46;
    var progress = reducedMotion.matches ? 1 : clamp((start - rect.top) / Math.max(1, start - end));

    state.process.dataset.tceProcessMotionProgress = progress.toFixed(3);
    state.cards.forEach(function (card, index) {
      applyCard(card, itemProgress(progress, index, state.cards.length, 0.075));
    });
    state.images.forEach(function (image, index) {
      applyImage(image, itemProgress(progress, index, state.images.length, 0.055));
    });
  }

  function updateAll() {
    frame = 0;
    states.forEach(updateState);
  }

  function scheduleUpdate() {
    if (!frame) frame = window.requestAnimationFrame(updateAll);
  }

  function startListening() {
    if (listening || reducedMotion.matches) return;
    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);
    listening = true;
  }

  function stopListening() {
    if (!listening) return;
    window.removeEventListener('scroll', scheduleUpdate);
    window.removeEventListener('resize', scheduleUpdate);
    listening = false;
  }

  function initializeProcess(process) {
    if (states.has(process)) return;

    var trigger = process.querySelector('.tce-home__process-steps');
    var cards = Array.from(process.querySelectorAll('.tce-home__process-steps > li'));
    var images = Array.from(process.querySelectorAll('.tce-home__process-image img'));
    if (!trigger || cards.length !== 5 || images.length !== 5) return;

    process.classList.add('tce-process-motion-scrub-ready');
    states.set(process, { process: process, trigger: trigger, cards: cards, images: images });
    startListening();
    updateState(states.get(process));
  }

  function init(root) {
    findProcesses(root || document).forEach(initializeProcess);
  }

  function destroy(root) {
    findProcesses(root || document).forEach(function (process) {
      var state = states.get(process);
      if (!state) return;

      state.cards.concat(state.images).forEach(function (node) {
        ['opacity', 'translate', 'rotate', 'scale', 'will-change'].forEach(function (property) {
          node.style.removeProperty(property);
        });
      });
      process.classList.remove('tce-process-motion-scrub-ready');
      delete process.dataset.tceProcessMotionProgress;
      states.delete(process);
    });

    if (!states.size) {
      stopListening();
      if (frame) window.cancelAnimationFrame(frame);
      frame = 0;
    }
  }

  window[namespace] = { init: init, destroy: destroy };
  init(document);

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target);
  });
})();
